import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, VuexModule } from 'vuex-module-decorators';

export interface AutoSyncTaskObject {
  started: boolean;
  taskArn: string;
  taskDefinitionArn: string;
  status: string;
}

@Module
export default class AutoSyncModule extends VuexModule {
  @Action
  [Actions.RUN_AUTO_SYNC]() {
    ApiService.setAuthorizationHeader();
    this.context.commit(Mutations.SET_ERROR, {});
    return ApiService.post('/indices/auto-sync/run', {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, {});
        return data.data;
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ??
          error.message ??
          'SOMETHING_WENT_WRONG';
        this.context.commit(Mutations.SET_ERROR, {
          autoSync: Array.isArray(message) ? message : [message],
        });
        return null;
      });
  }
}
